import Vue from 'vue'
import Meta from 'vue-meta'
// import { sync } from 'vuex-router-sync'
// import { createRouter } from './router';
import { createStore } from './client/store'
import App from './App.vue'

Vue.use(Meta)

export function createApp () {
  const store = createStore()

  const app = new Vue({
    store,
    render: h => h(App)
  })

  return { app, store }
}
